import { createContext } from "react";
import { SignalBadge } from "../SignalBadge";
import { AllocationControlColumn } from "./Calendar/CalendarListView/ListViewColumns";
import { AllocateCourseListText } from "./CourseList/AllocateCourseListText";
import { BaseHeaderLevel, HeadingLevel, RegistrationSlots } from "./types";

export const defaultRegistrationSlots: RegistrationSlots = {
  groupControls: (props) => <AllocationControlColumn {...props} />,
  activityBadge: (props) => <SignalBadge {...props} />,
  activityDescription: (props) => <AllocateCourseListText {...props} />,
};

type RegistrationOptions = {
  slots: RegistrationSlots;
  isDesktop: boolean;
  listOnly: boolean;
  headingLevel: (level: HeadingLevel) => HeadingLevel;
};

/** Shifts headings authored as a tree starting at 1 so that level 1 lands on `base`. */
export function makeHeadingLevel(
  base: BaseHeaderLevel
): (level: HeadingLevel) => HeadingLevel {
  return (level) => (base - 1 + level) as HeadingLevel;
}

export const RegistrationOptionsContext = createContext<RegistrationOptions>({
  slots: defaultRegistrationSlots,
  isDesktop: false,
  listOnly: false,
  headingLevel: makeHeadingLevel(1),
});
